// extracted by mini-css-extract-plugin
export default {"title":"GenresPage_title__EL-0B"};